/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GlobalConfigurationDtoPage } from '../../models/global-configuration-dto-page';

export interface ListGlobalConfigurations$Params {
  offset?: number;
  limit?: number;
  sorting?: Array<'id' | '-id' | 'tenantId' | '-tenantId' | 'name' | '-name' | 'isDefault' | '-isDefault' | 'createdAt' | '-createdAt' | 'updatedAt' | '-updatedAt' | 'budgetModuleEnabled' | '-budgetModuleEnabled' | 'projectConfigurableWorkPackageTypes' | '-projectConfigurableWorkPackageTypes' | 'projectConfigurableCostTypes' | '-projectConfigurableCostTypes' | 'projectConfigurableBudgetFlags' | '-projectConfigurableBudgetFlags' | 'defaultBudgetEnabled' | '-defaultBudgetEnabled' | 'defaultRevenueEnabled' | '-defaultRevenueEnabled' | 'defaultCashFlowEnabled' | '-defaultCashFlowEnabled' | 'defaultCostFlowEnabled' | '-defaultCostFlowEnabled' | 'defaultAllowMultipleBudget' | '-defaultAllowMultipleBudget' | 'defaultAllowBudgetCapOvercome' | '-defaultAllowBudgetCapOvercome' | 'defaultAllowEstimatesOvercome' | '-defaultAllowEstimatesOvercome' | 'defaultAllowNotAllocatedEffectives' | '-defaultAllowNotAllocatedEffectives' | 'defaultAllowUpdateBudgetVersionEstimates' | '-defaultAllowUpdateBudgetVersionEstimates' | 'projectGlobalLaborCostRequired' | '-projectGlobalLaborCostRequired' | 'projectWorkPackageEstimates' | '-projectWorkPackageEstimates' | 'projectPersonEstimates' | '-projectPersonEstimates' | 'enableOTP' | '-enableOTP' | 'data' | '-data'>;
}

export function listGlobalConfigurations(http: HttpClient, rootUrl: string, params?: ListGlobalConfigurations$Params, context?: HttpContext): Observable<StrictHttpResponse<GlobalConfigurationDtoPage>> {
  const rb = new RequestBuilder(rootUrl, listGlobalConfigurations.PATH, 'get');
  if (params) {
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sorting', params.sorting, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GlobalConfigurationDtoPage>;
    })
  );
}

listGlobalConfigurations.PATH = '/v0/globalConfigurations';
